<template>
  <div align="center" class="container-fluid">
    <page-header></page-header>
    <div class="navbar_website_map">
      <img src="../../assets/img/jt.jpg" width="9" height="9">
      {{$t('currlocation')}}
      : <router-link :to="{name:'login'}">{{$t('index')}}</router-link>
      <img src="../../assets/img/jt.gif">
      {{$t('upload_INV_PO')}}
    </div>
    <form id="fileupload" action="uploadInvPo.do?method=fileupload" method="POST" enctype="multipart/form-data">

      <div class="row" style="padding-left: 0px;">
        <div class="col-lg-7 col-sm-7">
          <input type="file" id="files" name="files" class="file-loading">
        </div>
        <div class="col-lg-5 col-sm-5" align="left">
          <a href="javascript:;" @click="downloadTemplate()">
            <span class="glyphicon glyphicon-cloud-download"></span>
            {{$t('m_Download_title1')}}
          </a>
        </div>
      </div>
    </form>
    <div style="overflow:auto;padding:10px;border-width:1px;">
      <div id="errorInfo" style="font-size:16px;line-height:25px;text-align: left;"></div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/infrastructure/layout/page-header.vue";
import store from "@/store";

export default {
  components: {
    PageHeader,
  },
  mounted() {
    require("../../../public/fileupload/fileinput");
    require("../../../public/fileupload/theme.min");
    require("../../../public/fileupload/locales/" + store.getters.lang);
    var module = require("@/assets/js/uploadmanifest");
    module.initUpload();
  },
  methods: {
    /**
     * 下载模板
     */
    downloadTemplate() {
      this.$utils.downloadFile(
        this.apiUrl +
          "UploadInvoicePurchaseOrder/downloadFile?fileName=GLS_INV_PO_template.xls",
        "GLS_INV_PO_template.xls"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../../../public/fileupload/css/fileinput.min.css");
@import url("../../../public/fileupload/css/theme.min.css");
@import "../../assets/css/index.css";
</style>